import {
    UPDATE_REVIEW_STATUS_START,
    UPDATE_REVIEW_STATUS_SUCCESS,
    UPDATE_REVIEW_STATUS_ERROR
} from '../../constants';
import { updateReviewStatus as mutation } from '../../lib/graphql';

export function updateReviewStatusAction({ bookingId, isReviewPageVisited }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: UPDATE_REVIEW_STATUS_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    bookingId,
                    isReviewPageVisited: Boolean(isReviewPageVisited)
                },
            })
            if (data?.updateReviewStatus?.status === 200) {
                dispatch({
                    type: UPDATE_REVIEW_STATUS_SUCCESS,
                });
            } else {
                dispatch({ type: UPDATE_REVIEW_STATUS_ERROR });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_REVIEW_STATUS_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}